export default __webpack_public_path__ + "c297616631961fffea64d861cf39c50a.jpg";